'use strict';

const PERFORMANCE_MEASURE_WHITE_LIST = [
  "microApp.eval.first.flexRemoteGnb",
  "microApp.eval.first.flexWidgetUserProfile",
  "microApp.eval.first.flexRemoteHome",
  "microApp.eval.first.flexWidgetGlobalFeatures",
  "fins.expense.page_root.to.evidence_table",
  "fins.expense.page_content.to.evidence_table"
];
function isWhiteListed(name) {
  return PERFORMANCE_MEASURE_WHITE_LIST.includes(name);
}

exports.PERFORMANCE_MEASURE_WHITE_LIST = PERFORMANCE_MEASURE_WHITE_LIST;
exports.isWhiteListed = isWhiteListed;
//# sourceMappingURL=transaction.cjs.map
